// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_CarregaCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /wizard_servicos/carrega_compromisso/{compromissoId}
 *
 * Loads compromisso data into the wizard. No body required — compromissoId is a URL path parameter.
 */
import { registerContract } from './validate'

export interface WizardServicos_CarregaCompromissoInput {}

registerContract('WizardServicos_CarregaCompromissoInput', {})
